import { useSiloWeb3 } from "./SiloWeb3Provider";
import { useBlockNumber } from "./useBlockNumber";

export const BlockNumber = () => {
  const { clientProvider } = useSiloWeb3();
  const blockNumber = useBlockNumber(clientProvider);

  /**
   * TODO: implement loading state for block number
   */
  const isLoading = false;

  if (!blockNumber) return null;

  return (
    <div className="fixed flex items-center gap-2 px-2 py-1 font-mono text-sm text-green-400 rounded-full bottom-5 sm:right-5 md:right-10 right-4 bg-shale-800">
      <span>{blockNumber}</span>
      <svg
        className="animate-spin"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isLoading ? (
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7472 10.0023H13.6576C12.8331 12.3311 10.6114 13.9994 8 13.9994C5.38864 13.9994 3.16692 12.3311 2.34243 10.0023H0.252778C1.14187 13.4512 4.27336 15.9994 8 15.9994C11.7266 15.9994 14.8581 13.4512 15.7472 10.0023ZM8.10109 0H7.89891C7.93256 -0.000416666 7.96625 -0.00062561 8 -0.00062561C8.03375 -0.00062561 8.06744 -0.000416666 8.10109 0ZM0.00012207 7.95471C4.07252e-05 7.96959 0 7.98448 0 7.99937C0 8.01427 4.07252e-05 8.02916 0.00012207 8.04404V7.95471Z"
            fill="currentColor"
          />
        ) : null}

        <circle cx="8" cy="7.99937" r="4" fill="currentColor" />
      </svg>
    </div>
  );
};
